import { gql } from "graphql-request"

const hedera = {
    name: 'hedera',
    title: 'Hedera Hashgraph Mainnet',
    currency: 'HBAR',
    check: false,
    regexp: '([^\\.\\W]|^)((0+\\.){2}(\\d+))([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        hedera(network: hedera) {
            address(address: {is: $address}){
                annotation
                balance: balance
                balance_usd:balance(in:USD)
            }
            ins: inputs(transferEntity: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            outs: outputs(transactionHash: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
        }
    }`,
    checkAddress: '0.0.3229',
}
export { hedera }
